module.exports = __webpack_public_path__ + "media/images/emblems/Melchnau-coat_of_arms-e6af77b4105b4254226fb282a86516ba.svg";